import { page } from 'vue-analytics'

/**
 * uses an if check to see if GA ID exists
 * @param {Function} method // method to be called
 * @param  {...any} args // arguments to pass to method
 */
const checkIdExists = (method, ...args) => {
    const id = process.env.VUE_APP_GA_ID
    if (id) {
        method.apply(null, args)
    }
}

/**
 * wrapper for page method of vue-analytics library
 * @param  {...any} args
 */
export const gaPage = (...args) => {
    return checkIdExists(page, ...args)
}
